module.exports = __webpack_public_path__ + "media/images/report_areas/gany-f01fa732dffc915634592ecd416d4aea.png";